import React from 'react';
import classNames from 'classnames';
import PageHeader from '@atlaskit/page-header';
import { Breadcrumbs, useFeatureToggle } from '@css-xp/base';
import { routePaths, ENABLE_DESIGN_ITERATION_1, STATSIG_FEATURE_GATES } from '@css-xp/ppc-constants';
import { HEADER } from '../constants/header';
import { ProductsSearch } from './products-search';
import { FilterOption } from '@css-xp/graphtypes/src/generated-types-new';
// import { usePartnerProductCatalogueContext } from '../contexts/product-catalogue-context';
// import { PartnerProductCatalogueItem } from '@atlassian/cssxp-types-product';
import './products-header.scss';

export const ProductsHeader = ({
  filterOptions,
  hideCatalogExcludedProducts,
  hideSearchBar = false,
}: {
  filterOptions?: FilterOption[];
  hideCatalogExcludedProducts?: boolean;
  hideSearchBar?: boolean;
}) => {
  // const { data } = usePartnerProductCatalogueContext();
  //
  // const products = data?.products?.nodes as PartnerProductCatalogueItem[];
  const [isEnabled] = useFeatureToggle();
  const isDesignIteration1Enabled = isEnabled(ENABLE_DESIGN_ITERATION_1);
  const isAppificationEnabled = isEnabled(STATSIG_FEATURE_GATES.ENABLE_APPIFICATION);
  const isAddonPhase2Enabled = isEnabled(STATSIG_FEATURE_GATES.ENABLE_ADD_ONS_PHASE_V2);

  const barContent = (
    <div className="ppc-search-filter">
      {!hideSearchBar && (
        <ProductsSearch filterOptions={filterOptions} hideCatalogExcludedProducts={hideCatalogExcludedProducts} />
      )}
      {/*<ProductsFilter data={products} />*/}
    </div>
  );

  const breadcrumbs = (
    <Breadcrumbs
      items={[
        {
          title: 'Home',
          href: routePaths.home,
        },
        {
          title: 'Catalog',
          href: routePaths.catalog,
        },
      ]}
    />
  );
  const headerText = React.useMemo(() => {
    return isAppificationEnabled ? HEADER.APPS : isAddonPhase2Enabled ? HEADER.PRODUCTS : HEADER.PRODUCTS_AND_APPS;
  }, [isAppificationEnabled, isAddonPhase2Enabled]);

  return (
    <div
      className={classNames({
        'ppc-products-header': true,
        'ppc-products-header-z-index-0': isDesignIteration1Enabled,
      })}
    >
      <PageHeader bottomBar={barContent} breadcrumbs={isDesignIteration1Enabled ? breadcrumbs : undefined}>
        {headerText}
      </PageHeader>
    </div>
  );
};
